import styled from "styled-components/macro";
import {
  FaBackward,
  FaFastBackward,
  FaForward,
  FaFastForward,
  FaSearchPlus,
  FaSearchMinus,
} from "react-icons/fa";

export const ControlPanelContainer = styled.div`
  font-size: 16px;
  background: #fff;
  border-radius: 5px;
  /* width: 25%; */
  margin: 30px;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ControlPanelLeft = styled.div`
  flex: 2;
  display: flex;
  justify-content: space-between;
`;

export const ControlPanelRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-left: 40px;
`;

export const PageZoomPlus = styled(FaSearchPlus)`
  font-size: 30px;
  cursor: ${({ isMaxZoom }) => (isMaxZoom ? "disabled" : "pointer")};
  color: ${({ isMaxZoom }) => (isMaxZoom ? "lightgray" : "#000")};
`;
export const PageZoomMinus = styled(FaSearchMinus)`
  font-size: 30px;
  cursor: ${({ isMinZoom }) => (isMinZoom ? "disabled" : "pointer")};
  color: ${({ isMinZoom }) => (isMinZoom ? "lightgray" : "#000")};
`;

export const PageBackward = styled(FaBackward)`
  cursor: ${({ isFirstPage }) => (isFirstPage ? "disabled" : "pointer")};
  color: ${({ isFirstPage }) => (isFirstPage ? "lightgray" : "#000")};
`;
export const PageBackwardFast = styled(FaFastBackward)`
  cursor: ${({ isFirstPage }) => (isFirstPage ? "disabled" : "pointer")};
  color: ${({ isFirstPage }) => (isFirstPage ? "lightgray" : "#000")};
`;

export const PageForward = styled(FaForward)`
  cursor: ${({ isLastPage }) => (isLastPage ? "disabled" : "pointer")};
  color: ${({ isLastPage }) => (isLastPage ? "lightgray" : "#000")};
`;

export const PageForwardFast = styled(FaFastForward)`
  cursor: ${({ isLastPage }) => (isLastPage ? "disabled" : "pointer")};
  color: ${({ isLastPage }) => (isLastPage ? "lightgray" : "#000")};
`;
